/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMatchWholeWord = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7.7 15 9 18.4l1.9-.7L6 5.3 1.1 17.6l1.9.7L4.3 15h3.4zM6 10.7l.9 2.3H5.1l.9-2.3zM1 20h22v2H1zM12 6v12h4c1.7 0 3-1.3 3-3v-2c0-1.7-1.3-3-3-3h-2V6h-2zm4 6c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1h-2v-4h2zM1 2h22v2H1zm20 4h2v12h-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgMatchWholeWord as MatchWholeWord };
